import axios from "axios";
import authHeader from "./AuthHeader";

const API_URL = process.env.VUE_APP_MS_CASC;


class CascService {
  lastPosition(payload) {
    return axios.post(`${API_URL}/lastPosition`, payload, {
      headers: authHeader(),
    });
  }

  lastPositionAndBatteryLevelForCustomer(payload) {
    return axios.post(`${API_URL}/lastPositionAndBatteryLevelForCustomer`, payload, {
      headers: authHeader(),
    });
  }

  findLocomotiveDetails(id) {
    return axios.get(`${API_URL}/locomotive/details?id=${id}`, {
      headers: authHeader(),
    });
  }

  lastPositionAndBatteryLevelAndFuellevelForCustomer(payload) {
    return axios.post(`${API_URL}/lastPositionAndBatteryLevelAndFuellevelForCustomer`, payload, {
      headers: authHeader(),
    });
  }

  geolocs(payload) {
    return axios.post(`${API_URL}/geolocs`, payload, { headers: authHeader() });
  }

  getBatteriesLoco(payload) {
    return axios.post(`${API_URL}/batteriesLoco`, payload, {
      headers: authHeader(),
    });
  }

  getLocoBatterysLevelForCustomer(payload) {
    return axios.post(`${API_URL}/batteriesLevelForCustomer`, payload, {
      headers: authHeader(),
    });
  }


  findDistance(payload) {
    return axios.post(`${API_URL}/distances`, payload, {
      headers: authHeader(),
    });
  }

  findTotalDistanceByCustomer(payload) {
    return axios.post(`${API_URL}/totalKmByCustomer`, payload, {
      headers: authHeader(),
    });
  }

  findTotalHmByCustomer(payload) {
    return axios.post(`${API_URL}/totalHmByCustomer`, payload, {
      headers: authHeader(),
    });
  }

  findTotalHmLocosByCustomerAndDays(payload) {
    return axios.post(`${API_URL}/totalHmLocosByCustomerAndDays`, payload, {
      headers: authHeader(),
    });
  }

  findTotalHmLocosByCustomer(payload) {
    return axios.post(`${API_URL}/totalHmLocosByCustomer`, payload, {
      headers: authHeader(),
    });
  }


  findTractionDistanceLocosByCustomerAndDays(payload) {
    return axios.post(`${API_URL}/tractionDistanceLocosByCustomerAndDays`, payload, { 
        headers: authHeader() }
    );
  }

  findVehicleDistanceLocosByCustomerAndDays(payload) {
    return axios.post(`${API_URL}/vehicleDistanceLocosByCustomerAndDays`, payload, { 
        headers: authHeader() }
    );
  }

  findAvgDistanceLocosByCustomer(payload) {
    return axios.post(
      `${API_URL}/avgDistanceLocosByCustomerAndMonth`,
      payload,
      { headers: authHeader() }
    );
  }

  findAvg(payload) {
    return axios.post(`${API_URL}/avg`, payload, { headers: authHeader() });
  }

  findTractionAvg(payload) {
    return axios.post(`${API_URL}/tractionAvg`, payload, { headers: authHeader() });
  }

  findVehicleAvg(payload) {
    return axios.post(`${API_URL}/vehicleAvg`, payload, { headers: authHeader() });
  }

  findOtherAvg(payload) {
    return axios.post(`${API_URL}/otherAvg`, payload, { headers: authHeader() });
  }

  findTotalDistanceLocosByCustomer(payload) {
    return axios.post(`${API_URL}/totalDistanceLocosByCustomer`, payload, {
      headers: authHeader(),
    });
  }

  findTractionDistanceLocosByCustomer(payload) {
    return axios.post(`${API_URL}/tractionDistanceLocosByCustomer`, payload, {
      headers: authHeader(),
    });
  }

  findVehicleDistanceLocosByCustomer(payload) {
    return axios.post(`${API_URL}/vehicleDistanceLocosByCustomer`, payload, {
      headers: authHeader(),
    });
  }

  findLocoPoi(payload) {
    return axios.post(`${API_URL}/pois`, payload, {
      headers: authHeader(),
    });
  }

  findLocoPoiByCountry(payload) {
    return axios.post(`${API_URL}/poisByCountry`, payload, {
      headers: authHeader(),
    });
  }

  findInfosLocosBatteryByCustomer(payload) {
    return axios.post(`${API_URL}/batteries`, payload, {
      headers: authHeader(),
    });
  }

  saveBatteryAlert(payload) {
    return axios.post(`${API_URL}/battery/subscriptions`, payload, {
      headers: authHeader(),
    });
  }

  loadBatteryAlert(payload) {
    return axios.get(`${API_URL}/battery/subscriptions?${payload}`, {
      headers: authHeader(),
    });
  }

  deleteBatteryAlert(payload) {
    return axios({
      method: "delete",
      headers: authHeader(),
      url: `${API_URL}/battery/subscriptions`,
      data: payload,
    });
  }

  savePoiAlert(payload) {
    return axios.post(`${API_URL}/poi/subscriptions`, payload, {
      headers: authHeader(),
    });
  }

  loadPoiAlert(payload) {
    return axios.get(`${API_URL}/poi/subscriptions?${payload}`, {
      headers: authHeader(),
    });
  }

  deletePoiAlert(payload) {
    return axios({
      method: "delete",
      headers: authHeader(),
      url: `${API_URL}/poi/subscriptions`,
      data: payload,
    });
  }
}

export default new CascService();
